module.exports = __webpack_public_path__ + "static/media/teste.5a5cfaa8.jpg";